// Create a clean black, grey, and white theme for survey
export const createCompassSurveyTheme = (): {
  colorPalette: string;
  isPanelless: boolean;
  cssVariables: Record<string, string>;
} => {
  return {
    colorPalette: "light",
    isPanelless: false,
    cssVariables: {
      // Primary colors - Black and Grey
      "--sjs-primary-backcolor": "#333333",
      "--sjs-primary-forecolor": "#FFFFFF",
      "--sjs-primary-backcolor-light": "#666666",
      "--sjs-primary-backcolor-dark": "#000000",
      
      // Secondary colors - Grey
      "--sjs-secondary-backcolor": "#666666",
      "--sjs-secondary-forecolor": "#FFFFFF",
      
      // Background colors - White and Light Grey
      "--sjs-general-backcolor": "#FFFFFF",
      "--sjs-general-backcolor-dim": "#F5F5F5",
      
      // Font
      "--sjs-font-family": "'Open Sans', Arial, sans-serif",
      "--sjs-font-size": "16px",
        
      // Question styling
      "--sjs-question-backcolor": "#FFFFFF",
      "--sjs-question-forecolor": "#000000",
      "--sjs-question-border": "#CCCCCC",
      "--sjs-question-border-radius": "4px",
      "--sjs-question-shadow": "none",
      
      // Button styling - Dark Grey/Black
      "--sjs-button-backcolor": "#333333",
      "--sjs-button-forecolor": "#FFFFFF",
      "--sjs-button-border": "#333333",
      "--sjs-button-border-radius": "4px",
      
      // Input styling - subtle appearance
      "--sjs-input-backcolor": "#F5F5F5",
      "--sjs-input-forecolor": "#333333",
      "--sjs-input-border": "#E0E0E0",
      "--sjs-input-border-radius": "4px",
      
      // Input focus state
      "--sjs-input-backcolor-focus": "#FFFFFF",
      "--sjs-input-border-focus": "#999999",
      
      // Checkbox/Radio checked state
      "--sjs-checkbox-backcolor": "#666666",
      "--sjs-checkbox-forecolor": "#FFFFFF",
      "--sjs-radio-backcolor": "#666666",
      "--sjs-radio-forecolor": "#FFFFFF",
      
      // Panel styling
      "--sjs-panel-backcolor": "#FFFFFF",
      "--sjs-panel-forecolor": "#000000",
      "--sjs-panel-border": "#CCCCCC",
      "--sjs-panel-border-radius": "4px",
      
      // Progress bar
      "--sjs-progressbar-backcolor": "#333333",
      "--sjs-progressbar-forecolor": "#FFFFFF",
      
      // Error colors - Red for errors only
      "--sjs-error-backcolor": "#DC3545",
      "--sjs-error-forecolor": "#FFFFFF"
    }
  };
};
